import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.issues.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-admin-issues-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.admin.issues.list/view.scss */
/* src/app/portal.admin.issues.list/view.scss: no such file or directory */`],
})
export class PortalAdminIssuesListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public searchTerm = '';
    public statusFilter = 'all';

    public issues: any = [];

    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public statusCount = {
        notice: 0,
        submit: 0,
        process: 0,
        finish: 0,
        cancel: 0
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 이슈 - MY KREONET");
        await this.load(this.pagenation.page);
        await this.updateStatusCount()
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.pagenation.page = page;
        await this.service.render();
        const { code, data } = await wiz.call("load", { page: this.pagenation.page, search: this.searchTerm, mode: this.statusFilter });
        if (code != 200) return await this.service.alert.error("Error!");
        this.issues = data.issues;
        this.pagenation.end = data.lastpage;

        await this.service.render();
    }

    public async search(text: any) {
        this.searchTerm = text;
        // if (this.searchTerm.length === 0) return await this.service.alert.warning("검색어를 입력해주세요.");
        this.pageLoad(1);
    }

    private changeStatus() {
        this.searchTerm = '';
        this.load(1);
    }

    public getStatus(status: string) {
        switch (status) {
            case 'notice': return '공지';
            case 'submit': return '접수완료';
            case 'process': return '처리중';
            case 'finish': return '처리완료';
            case 'cancel': return '취소';
            default: return '-';
        }
    }

    public getStatusColor(status: string) {
        switch (status) {
            case 'notice': return 'bg-blue-100 text-blue-800';
            case 'submit': return 'bg-green-100 text-green-800';
            case 'process': return 'bg-yellow-100 text-yellow-800';
            case 'finish': return 'bg-gray-100 text-gray-800';
            case 'cancel': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    public getPriorityColor(priority: string) {
        switch (priority) {
            case 'high': return 'bg-red-100 text-red-800';
            case 'middle': return 'bg-yellow-100 text-yellow-800';
            case 'low': return 'bg-green-100 text-green-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    private updateStatusCount() {
        if (!this.issues) return;
        this.statusCount = {
            notice: this.issues.filter(t => t.status === 'notice').length,
            submit: this.issues.filter(t => t.status === 'submit').length,
            process: this.issues.filter(t => t.status === 'process').length,
            finish: this.issues.filter(t => t.status === 'finish').length,
            cancel: this.issues.filter(t => t.status === 'cancel').length
        };
    }
}

export default PortalAdminIssuesListComponent;